import { render, staticRenderFns } from "./UserBenefitStatistical.vue?vue&type=template&id=4ca7a7a5&scoped=true&"
import script from "./UserBenefitStatistical.vue?vue&type=script&lang=js&"
export * from "./UserBenefitStatistical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7a7a5",
  null
  
)

export default component.exports